import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3127148e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3127148e&prod&scoped=true&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=3127148e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3127148e",
  null
  
)

export default component.exports